import type { FC, ReactNode } from 'react';
import { Box, Divider, Typography, useTheme } from '@mui/material';

import { styles } from './index.styles';

interface ChartBackgroundProps {
  maxValue: number;
  numGridLines?: number;
  labelsEachNthRow?: number;
  showDecimals?: number;
  children: ReactNode;
  yAxisLabel?: string;
  hideGridLabels?: boolean;
  isRelative?: boolean;
}

const ChartBackground: FC<ChartBackgroundProps> = ({
  maxValue,
  numGridLines = 10,
  labelsEachNthRow = 2,
  showDecimals = 0,
  children,
  yAxisLabel,
  hideGridLabels,
  isRelative,
}) => {
  const {
    colors: { neutral },
  } = useTheme();
  return (
    <Box sx={styles.chartBackground}>
      <Box sx={styles.chartGrid}>
        {[...Array(numGridLines + 1).keys()].reverse().map((num, index) => (
          <Box
            key={num}
            sx={{
              ...styles.chartGridRow,
              height: `${100 / numGridLines || 1}%`,
            }}
          >
            {!hideGridLabels && (
              <Typography
                variant="body3"
                sx={[
                  {
                    fontWeight: 600,
                  },
                  styles.chartGridRowLabel,
                ]}
              >
                {(index === 0 && yAxisLabel) ||
                  (!num || num % labelsEachNthRow
                    ? ''
                    : ((maxValue * num) / numGridLines).toFixed(showDecimals) +
                      (isRelative ? '%' : ''))}
              </Typography>
            )}

            <Divider sx={{ flexGrow: 1, borderColor: neutral[100] }} />
          </Box>
        ))}
      </Box>
      <Box
        sx={[
          {
            ...styles.chartData,
          },
          hideGridLabels
            ? {
                marginLeft: 0,
              }
            : {
                marginLeft: styles.chartData.marginLeft,
              },
          hideGridLabels
            ? {
                marginRight: 0,
              }
            : {
                marginRight: styles.chartData.marginRight,
              },
        ]}
      >
        {children}
      </Box>
    </Box>
  );
};
export default ChartBackground;
